module.exports = __webpack_public_path__ + "img/zip-cover.8fa85809.png";